module.exports = __webpack_public_path__ + "static/offer-modal-mobile_c-fb0b4118dc59761fef4a1d9cb56b8782.webp";